module.exports = __webpack_public_path__ + "img/banya-text_bg.39517e7a.svg";